// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"95d1e292","977":"3bb549b2"}[chunkId] + ".chunk.js";
};